import Document from "@tiptap/extension-document";
import Bold from "@tiptap/extension-bold";
import BulletList from "@tiptap/extension-bullet-list";
import HardBreak from "@tiptap/extension-hard-break";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import History from "@tiptap/extension-history";
import Italic from "@tiptap/extension-italic";
import ListItem from "@tiptap/extension-list-item";
import OrderedList from "@tiptap/extension-ordered-list";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Typography from "@tiptap/extension-typography";
import type { Variables } from "@/lib/sparxs/metadataSchemas";
import { VariableTokenExtension } from "./variables/variableTokenExtension";
import { VariableSuggestionExtension } from "./variables/variableSuggestionExtension";
import { DirectiveSuggestionExtension } from "./directives/suggestion/extension/extension";
import { MarkdownPreviewDecorationsExtension } from "./markdown/markdownPreviewDecorationsPlugin";
import {
  buildWysiwygExtensionsForFeatureBlacklist,
  type RteFeature,
} from "./richTextEditorFeatureBlacklist";

const WYSIWYG_EXTENSIONS_BASE = [
  Document,
  Paragraph,
  Text,
  Bold,
  Italic,
  HardBreak,
  HorizontalRule,
  History,
  Typography,
  BulletList,
  OrderedList,
  ListItem,
];

const buildWysiwygExtensions = (variables: Variables[]) => [
  ...WYSIWYG_EXTENSIONS_BASE,
  VariableSuggestionExtension.configure({ char: "{", variables }),
  DirectiveSuggestionExtension.configure({ variables }),
  VariableTokenExtension.configure({ variables }),
];

export const buildWysiwygExtensionsWithBlacklist = (
  variables: Variables[],
  featureBlacklist: readonly RteFeature[],
) => {
  if (featureBlacklist.length === 0) {
    return buildWysiwygExtensions(variables);
  }
  return buildWysiwygExtensionsForFeatureBlacklist(variables, featureBlacklist);
};

export const MARKDOWN_EXTENSIONS = [
  Document,
  Paragraph,
  Text,
  HardBreak,
  History,
  MarkdownPreviewDecorationsExtension,
];
